import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    fetch: (config: AxiosRequestConfig) =>
        api.get("/recipes/categories", config),
    create: (data: object, config: AxiosRequestConfig) =>
        api.post("/recipes/categories", data, config),
    delete: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/recipes/categories/${url.id}`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/recipes/categories/${url.id}`, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/recipes/categories/${url.id}`, data, config),
};

export default requests;
